"use client"
/* */
const text = "flow--text";
const light = "flow--text--light";
const dark = "flow--text--dark";
const icon = "flow--text--icon";
const styles = {
	text: text,
	light: light,
	dark: dark,
	icon: icon,
	"align-start": "flow--text--align-start",
	"align-center": "flow--text--align-center",
	"align-end": "flow--text--align-end",
	"wrap-wrap": "flow--text--wrap-wrap",
	"wrap-balance": "flow--text--wrap-balance",
	"wrap-pretty": "flow--text--wrap-pretty"
};

export { dark, styles as default, icon, light, text };
//# sourceMappingURL=Text.module.scss.mjs.map
